import NoStoriesInfo from './no-stories-info';

export default NoStoriesInfo;
